<!-- Top Navbar Area -->
<nav class="navbar top-navbar navbar-expand is-sticky" style="background-color: #143a61!important;" id="navbar">
    <div class="collapse navbar-collapse" id="navbarSupportContent">
        <div class="responsive-burger-menu d-block d-lg-none">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
        <span class="head  hb_title">&nbsp;&nbsp; </span>
        <ul class="navbar-nav left-nav align-items-center" style="    margin-top: -10px;
        margin-left: 10px;">



            <li style="FONT-FAMILY: system-ui;
FONT-WEIGHT: 700;
color: white;
padding-top: 4px;"> {{this.appservice.Header_Disp}}</li>



        </ul>

        <form class="nav-search-form d-none ml-auto d-md-block">
            <div style="line-height: 45px;">&nbsp;</div>
        </form>

        <ul class="navbar-nav right-nav align-items-center" style="right: 0px;
        position: absolute;">
            <li></li>

<li class="nav-item notification-box dropdown mhide d-flex">
        <a class="nav-link dropdown-toggle" (click)="openSupportTicket()" data-tip="Help" aria-label="Help">
          <i class="bx bx-help-circle" style="color: white;"></i>
        </a>
      </li>
            <li class="nav-item dropdown profile-nav-item">
                <a href="#" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <div class="menu-profile">
                        <span style="font-size: 17px; color: white;" class="name">Hi! {{appservice.Emp_Name}}</span>
                        <img src="assets/img/user1.jpg" class="rounded-circle" alt="image">
                    </div>
                </a>
                <div class="dropdown-menu">
                    <div class="dropdown-header d-flex flex-column align-items-center">
                        <div class="figure mb-3">
                            <img src="assets/img/user1.jpg" class="rounded-circle" alt="image">
                        </div>

                        <div class="info text-center">
                            <span class="name">{{data.UM_Full_Name}}</span>
                            <p style="margin-bottom: 0;">{{data.UM_User_Name}}</p>
                            <p style="margin-bottom: 0;">{{appservice.Emp_Dept}}</p>
                            <p style="margin-bottom: 0;">{{appservice.Emp_Approver_Name}}</p>


                        </div>
                    </div>

                    <div class="dropdown-body">
                        <ul class="profile-nav p-0 pt-3">






                            <li class="nav-item">
                                <a class="nav-link" routerLink="settings/change-password">
                                    <i class='bx bx-cog'></i> <span style="color: #000;">Change Password</span>
                                </a>
                            </li>

                            <li class="nav-item">
                                <a (click)="logout()" class="nav-link">
                                    <i class='bx bx-log-out'></i> <span style="color: #000;">Logout</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                </div>
            </li>
        </ul>
    </div>


</nav>

<!-- Play Button Slider -->
<div [ngClass]="appservice.isShowPlayButton?'playBtnRow':'d-none'">
    <div class="nopad" class="D_Footer d-flex align-items-center">
        <div class="toggleArrowIcons">
            <span class="d-flex align-items-center" (click)="onPlayButtonShow()"><i class='bx '
                    [ngClass]="appservice.isPlayToggleShow?'bx-chevron-left':'bx-chevron-right'"
                    id="arrowIconChange"></i></span>
        </div>
        <ul class="list-inline playBtnMenu d-flex align-items-center mb-0" *ngIf="appservice.isPlayToggleShow">
            <li (click)="appservice.Previous_Page()">
                <span class="skipIcon"><i class="bx bx-skip-previous"></i></span>
            </li>
            <li *ngIf="appservice.DB_Mode=='Play'" (click)="appservice.DB_Mode='Pause'">
                <span><i class="bx bx-pause"></i></span>
            </li>
            <li *ngIf="appservice.DB_Mode=='Pause'" (click)="appservice.DB_Mode='Play'">
                <span><i class="bx bx-play"></i></span>
            </li>
            <li (click)="appservice.Next_Page()">
                <span><i class="bx bx-skip-next"></i></span>
            </li>
        </ul>
    </div>
</div>

<!-- End Top Navbar Area -->